import GrayMetricsModel from './gray-metrics-model'
import NewView from '../red-metrics/red-metrics-new'
import AncestorStep from '../common/ancestor-step'
import ReportFilterUtil from '../common/report-filter-util'

var GrayMetricsPath = {
	icon: 'measure-value',
	key: 'report.grayMetricsReport.title',
	steps: [AncestorStep, {
		titleCode: 'report.grayMetricsReport.title',
		view: NewView,
		validate: function(attrs, opts) {
			//must select a node or ancestor
			return !ReportFilterUtil.hasAncestorValues(attrs, 'scorecardNodeIds')
				&& !ReportFilterUtil.hasValues(attrs, 'scorecardNodeIds')
		}
	}],
	model: GrayMetricsModel
}

export default GrayMetricsPath

GrayMetricsPath.__filename__ = 'reports/wizard/gray-metrics/gray-metrics-path.js'
